<template>
  <div class="about-page">
    <section class="about-hero">
      <div class="container about-hero-inner">
      </div>
    </section>

    <section id="company" class="about-profile">
      <div class="container">
        <div class="center-title">
          <span>COMPANY PROFILE</span>
          <h2>公司简介</h2>
        </div>
        <div class="profile-grid">
          <div class="tower-visual">
            <img src="@/assets/image/company.png" alt="公司简介">
          </div>
          <div class="profile-copy">
            <p>
              深圳市千讯云创科技有限公司(以下简称“千讯云创”)，是一家以GPS/北斗位置服务为核心的物联网高科技企业；专业从事GPS/北斗位置服务平台开发、GPS/北斗定位终端研发、生产、销售，提供一站式位置服务解决方案，支持ODM/OEM，应用自主研发的一系列GPS/北斗定位物联网生态体系，服务于全球170多个国家和地区，为客户提供精准、高效、可靠的定位服务解决方案。
            </p>
            <p>
              千讯云创拥有研发人员近40余人，包含物联网行业资深人才、中南大学硕士、国内知名大学本科及大专业学历，集合服务器部署、IOS/安卓/鸿蒙APP开发、WEB端/小程序开发、GPS硬件开发、嵌入式软件开发、结构工程师、软硬件测试工程师等物联网领域专业人才。
            </p>
            <p>
              千讯云创物联网生态涉及车辆定位、金融风控、汽车租赁、两轮电动车、新能源汽车、智慧物流、智慧环卫、智慧校园、智慧牧场、人员宠物安全守护等领域。
            </p>
            <span class="blue-tag">科技引领未来 定位创造价值</span>
          </div>
        </div>

        <div class="about-stat-strip">
          <div v-for="stat in stats" :key="stat.label" class="about-stat-item">
            <strong>{{ stat.value }}</strong>
            <span>{{ stat.label }}</span>
          </div>
        </div>
      </div>
    </section>

    <section id="team" class="about-team">
      <div class="container">
        <div class="center-title">
          <span>R&amp;D TEAM AND TECHNICAL STRENGTH</span>
          <h2>研发团队与技术实力</h2>
        </div>
        <div class="team-layout">
          <div class="team-copy">
            <article v-for="item in teamPoints" :key="item.title" class="team-point">
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </article>
          </div>
          <div class="team-orbit">
            <img :src="tecImage" alt="研发团队与技术实力">
          </div>
        </div>
        <div class="capability-grid">
          <article v-for="item in capabilities" :key="item.title" class="capability-card">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
            <img :src="item.icon" :alt="item.title">
          </article>
        </div>
      </div>
    </section>

    <section id="global" class="about-global">
      <div class="container">
        <div class="center-title">
          <span>GLOBAL POSITIONING EXCELLENCE DATA</span>
          <h2>全球定位 卓越数据</h2>
        </div>
        <p class="global-desc">
          截至目前，业务遍布了中国、东南亚、南北美洲、欧洲、中东和非洲等170多个国家和地区，累计出口千万余台设备。拥有多项发明专利，先后通过了CE、FCC、RSM、GSMA、ROHS、ISO9001、CCC等国内外权威机构认证。
        </p>
        <div class="map-visual">
          <img src="@/assets/image/early.png" alt="全球定位卓越数据">
        </div>
      </div>
    </section>

    <section id="honors" class="about-honors">
      <div class="container">
        <div class="center-title">
          <span>SOFTWARE COPYRIGHT</span>
          <h2>软件著作权</h2>
        </div>
      </div>
      <div class="copyright-marquee" aria-label="软件著作权证书轮播">
        <div class="copyright-track">
          <article
            v-for="(card, index) in copyrightLoop"
            :key="`${card.alt}-${index}`"
            class="copyright-card"
          >
            <img :src="card.image" :alt="card.alt">
          </article>
        </div>
      </div>
      <p class="copyright-desc">获得设计发明类、实用新型类专利和软件著作权共计百余项</p>
    </section>

    <section id="certification" class="certification-section">
      <div class="container certification-layout">
        <div class="certification-grid" aria-label="认证资质展示" @mouseleave="hoverCertificationIndex = null">
          <button
            v-for="(item, index) in certifications"
            :key="item.label"
            type="button"
            class="certification-item"
            :class="{ active: isCertificationActive(index) }"
            @click="hoverCertificationIndex = index"
            @mouseenter="hoverCertificationIndex = index"
          >
            <img
              :src="isCertificationActive(index) ? item.icon : item.activeIcon"
              :alt="item.label"
            >
            <span v-if="hoverCertificationIndex === index">{{ item.label }}</span>
          </button>
        </div>
        <div class="certification-trophy">
          <img src="@/assets/image/icon_cer11.png" alt="冠军奖杯">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getStoredLanguage } from '../i18n/localLanguage'

export default {
  name: 'AboutView',
  data() {
    return {
      currentLanguage: getStoredLanguage(),
      hoverCertificationIndex: null,
      stats: [
        { value: '1000万+', label: '企业服务客户' },
        { value: '1500万+', label: '平台监控设备' },
        { value: '800+', label: '独立研发创新型产品' },
        { value: '160+', label: '拥有独立知识产权' }
      ],
      teamPoints: [
        {
          title: '40+研发精英，打造全球定位服务的技术引擎',
          desc: '千讯云创拥有一支由40余名研发精英组成的核心团队，成员涵盖物联网行业资深专家、硕士团队、国内知名高校本科及专科技术人才。'
        },
        {
          title: '从芯片到云端，定义GPS定位服务的未来',
          desc: '自主研发高精度定位算法，融合北斗/GPS双模定位、惯性导航技术，实现复杂环境下的连续定位。云端平台支持千万级设备并发接入与实时数据处理。'
        }
      ],
      capabilities: [
        { title: '软件端', desc: '覆盖iOS、安卓、鸿蒙多平台APP开发、Web端及小程序开发，支持跨平台兼容性优化。', icon: require('@/assets/image/dev1.png') },
        { title: '硬件端', desc: '专业从事GPS/北斗定位终端研发，包括芯片选型、PCB设计、低功耗优化及抗干扰技术攻关。', icon: require('@/assets/image/dev2.png') },
        { title: '系统层', desc: '嵌入式软件开发团队精通Linux、RTOS等系统，确保设备与云端的高效通信。', icon: require('@/assets/image/dev3.png') },
        { title: '测试与部署', desc: '配备软硬件测试工程师，执行严格的可靠性测试，防水等，并支持全球服务器部署与运维。', icon: require('@/assets/image/dev4.png') }
      ],
      copyrightCards: [
        { image: require('@/assets/image/card1.png'), alt: '软件著作权证书1' },
        { image: require('@/assets/image/card2.png'), alt: '软件著作权证书2' },
        { image: require('@/assets/image/card3.png'), alt: '软件著作权证书3' },
        { image: require('@/assets/image/card4.png'), alt: '软件著作权证书4' },
        { image: require('@/assets/image/card5.png'), alt: '软件著作权证书5' },
        { image: require('@/assets/image/card6.png'), alt: '软件著作权证书6' },
        { image: require('@/assets/image/card7.png'), alt: '软件著作权证书7' },
        { image: require('@/assets/image/card8.png'), alt: '软件著作权证书8' },
        { image: require('@/assets/image/card9.png'), alt: '软件著作权证书9' },
        { image: require('@/assets/image/card10.png'), alt: '软件著作权证书10' }
      ],
      certifications: [
        { label: 'CE安全认证', icon: require('@/assets/image/cer1_0.png'), activeIcon: require('@/assets/image/cer1_1.png') },
        { label: 'FCC认证', icon: require('@/assets/image/cer2_0.png'), activeIcon: require('@/assets/image/cer2_1.png') },
        { label: 'CCC认证', icon: require('@/assets/image/cer3_0.png'), activeIcon: require('@/assets/image/cer3_1.png') },
        { label: 'RoHS认证', icon: require('@/assets/image/cer4_0.png'), activeIcon: require('@/assets/image/cer4_1.png') },
        { label: 'GSMA认证', icon: require('@/assets/image/cer5_0.png'), activeIcon: require('@/assets/image/cer5_1.png') },
        { label: 'ISO9001', icon: require('@/assets/image/cer6_0.png'), activeIcon: require('@/assets/image/cer6_1.png') },
        { label: 'GPS认证', icon: require('@/assets/image/cer7_0.png'), activeIcon: require('@/assets/image/cer7_1.png') },
        { label: 'IAF认证', icon: require('@/assets/image/cer8_0.png'), activeIcon: require('@/assets/image/cer8_1.png') },
        { label: 'CQC认证', icon: require('@/assets/image/cer9_0.png'), activeIcon: require('@/assets/image/cer9_1.png') },
        { label: '国际认证', icon: require('@/assets/image/cer10_0.png'), activeIcon: require('@/assets/image/cer10_1.png') }
      ]
    }
  },
  computed: {
    tecImage() {
      return this.currentLanguage === 'en' ? require('@/assets/image/tec_en.png') : require('@/assets/image/tec.png')
    },
    copyrightLoop() {
      return this.copyrightCards.concat(this.copyrightCards)
    }
  },
  mounted() {
    window.addEventListener('site-language-change', this.syncLanguage)
  },
  beforeDestroy() {
    window.removeEventListener('site-language-change', this.syncLanguage)
  },
  methods: {
    syncLanguage(event) {
      this.currentLanguage = event.detail || getStoredLanguage()
    },
    isCertificationActive(index) {
      return this.hoverCertificationIndex === index || (this.hoverCertificationIndex === null && index === 0)
    }
  }
}
</script>
